export const NONE = "None";
export const NEW = "New";
export const OPEN = "Open";
export const EXPORT = "Export";
export const THEME = "Theme";
